import { performLogin } from "../dataLayer/login";

class LoginManager {

    // Method to handle user login for the signed-in Microsoft account
    async login(): Promise<any> {
        try {
            // Call the performLogin function to attempt the login
            const authData = await performLogin();

            // Log the successful login for debugging purposes
            console.log("Login successful:", authData);

            // Return the authentication data after a successful login
            return authData;

        } catch (error) {
            // Log any errors that occur during the login attempt
            console.error("Error during login:", error);

            // Rethrow the error so that it can be handled by the calling code
            throw error;
        }
    }

}

// Export an instance of the LoginManager class for use throughout the application
export default new LoginManager();
